import { setActionStatusPending, setActionStatusSuccess, setActionStatusError } from '@/store/helpers';

import {
  GET_TOKEN,
  GET_RESET_PASSWORD_TOKEN,
  SET_TWO_FACTOR_AUTH_REQUIRED,
  REMOVE_TWO_FACTOR_AUTH_REQUIRED
} from './mutationTypes';

export default {
  [GET_TOKEN](state, loginRequest) {
    state.loginRequest = loginRequest;
  },

  [GET_RESET_PASSWORD_TOKEN](state, resetPasswordRequest) {
    state.resetPasswordRequest = resetPasswordRequest;
  },

  [SET_TWO_FACTOR_AUTH_REQUIRED](state) {
    state.twoFactorAuthRequired = true;
  },

  [REMOVE_TWO_FACTOR_AUTH_REQUIRED](state) {
    state.loginRequest = {};
    state.resetPasswordRequest = {};
    state.twoFactorAuthRequired = false;
  },

  setActionStatusPending,
  setActionStatusSuccess,
  setActionStatusError,
};